/** 备注：当前版本需要IPCC语音服务器ACD话后时间勾选，如不勾选，会造成js等逻辑错误！！！
 * 	update:
 * 		1、较20220106版本更新 当同一个座席连接服务器，系统给与之前的座席 强制下线的提示
 * */
 import  * as phonPopup from '../phone-popup/phone-popup.js'
 import util from '../../js/util';
 var boxId ;
 var websocket = null;
 var agentVersion = '2022.01.06';
 var agentProxy;
 agentProxy = {
	 /**
	  * 部分常量参数
	  */
	 constant: {
		 /**
		  * 通话未被接入
		  */
		 'call_user_not_use': 0,
		 /**
		  * 通话正在被接入
		  */
		 'call_user_accessing': 1,
		 /**
		  * 振铃
		  */
		 'call_user_ring': 2,
		 /**
		  * 正在通话
		  */
		 'call_user_answer': 3,
		 /**
		  * 通话保持
		  */
		 'call_user_hold': 4,
		 /**
		  * 通话释放
		  */
		 'call_user_release': 5,
		 /**
		  * 通话为呼出
		  */
		 'call_user_out_side': 0,
		 /**
		  * 通话是呼入
		  */
		 'call_user_in_side': 1,
		 /**
		  * 该路通话正使用  未hold
		  */
		 'call_user_taking': 1,
		 /**
		  * 该路通话未使用  hold
		  */
		 'call_user_not_taking': 0,
		 /**
		  * 坐席 非取消离席状态
		  */
		 'login_user_not_cancel_leaveData': 1,
		 /**
		  * 坐席 取消离席
		  */
		 'login_user_cancel_leaveData': 0,
		 /**
		  * 坐席点击 离席 签出
		  */
		 'login_user_leaveData_case': 'leaveData',
		 /**
		  * 来电自动应答
		  */
		 'call_allow_auto_answer': 1,
		 /**
		  * 来电不能自动应答
		  */
		 'call_not_allow_auto_answer': 0,
	 },
	 /**
	  * 提示框
	  * @param title 标题
	  * @param msg 提示内容
	  */
	 promptBox: function (title,msg) {
		 if(!title || title == null) title = '提示';
		 var html = '<div class="prompt-div-back">'
			 + '<div class="prompt-div-content">'
			 + '<div class="prompt-div-title">'
			 + '<span class="content-title">'+title+'</span>'
			 + '<span class="prompt-div-close">X</span></div>'
			 + '<div class="prompt-show-msg">'
			 + '<img src="">'
			 + '<div class="show-msg" title="'+msg+'">'+msg+'</div></div></div></div>'
		 $('body').append(html);
		 $('.prompt-div-back .prompt-div-content .prompt-div-title .prompt-div-close').click(function(){
			 $('.prompt-div-back').remove();
		 });
	 },
	 /**
	  * 当前通话的ID
	  */
	 curTakingId: 0,
	 /**
	  * 质检前 坐席的状态
	  */
	 begoreQualityPageUserStatus:null,
	 /**
	  * 质检成功后 坐席状态栏 显示
	  */
	 afterQualityPageSuccessStatus:null,
	 /**
	  * 被监听的 用户
	  */
	 qualityUserCode:'',
	 /**
	  * 取消 监听需要发送的msg
	  */
	 qualityNextStepMsg:null,
	 /**
	  * 向 agentserver 推送信息  注意 传入的是个对象
	  * @param object
	  */
	 sendMsgToAgentServer: function (object) {
		 if(websocket.readyState == 1){ // 这个说明  websocket 已经连接上
			 var str = JSON.stringify(object);
			 console.info('Send : ',str);
			 websocket.send(JSON.stringify(object));
		 }
	 },
	 /**
	  * 坐席条状态信息
	  */
	 leaveData: {
		 'leaveTel': '',
		 'ckeckStatus': 0 // 判断 是否是 勾选 离席模式 进行的操作 0 否   1 yes
	 },
	 /**
	  * 切换按钮点击状态及绑定事件（btns：['checkIn','phoneIncoming',······,'answer']）
	  * @param btns
	  */
	 btnClickAbles: function (btns) { //
		 var that = this;
		 $('#agentBtnList [by-model]').removeClass('able').addClass('disable').unbind('click');
		 if (btns == '' || btns.length == 0) return;
		 btns.push('chat'); // 默认 chat 按钮
		 btns.push('extend');// 默认 扩展 按钮
		 if (that.curLoginUser.Supervisor == '2') {
			 btns.push('qualityTesting'); // 如果是主管 质检按钮 可操作
			 btns.push('qualityTestingCancel');
		 }
		 $.each(btns, function (idx, btn) {
			 $('#agentBtnList [by-model="' + btn + '"]').removeClass('disable').addClass('able');
			 $('#agentBtnList [by-model="' + btn + '"]').bind('click', function () {
				 that[btn]();
			 });
		 });
	 },
	 /**
	  * 增加 按钮的 可点击事件
	  * @param btns
	  */
	 btnClickAblesAdd: function (btns) {
		 var that = this;
		 $.each(btns, function (idx, btn) {
			 $('#agentBtnList [by-model="' + btn + '"]').removeClass('disable').addClass('able');
			 $('#agentBtnList [by-model="' + btn + '"]').bind('click', function () {
				 that[btn]();
			 });
		 });
	 },
	 /**
	  * 消减指定按钮的 点击 事件
	  */
	 btnClickAblesMusic: function (btns) {
		 $.each(btns, function (idx, btn) {
			 $('#agentBtnList [by-model="' + btn + '"]').removeClass('able').addClass('disable').unbind('click');
		 });
	 },
	 /**
	  * 获取 坐席条状态栏的信息
	  */
	 getShowAgentStatus:function(){
		 return {
			 'loginContent':$('.bottom [by-model="statusLogin"]').text(),
			 'workContent' :$('.bottom [by-model="statusWork"]').text(),
			 'phoneContent' :$('.bottom [by-model="statusPhone"]').text(),
			 'versionContent':$('.bottom [by-model="emptyStatus"]').text(),
		 };
	 },
	 /**
	  * 坐席条最后一行 显示内容
	  * @param loginContent
	  * @param workContent
	  * @param phoneContent
	  * @param versionContent
	  */
	 setShowAgentStatus: function (loginContent, workContent, phoneContent, versionContent) {
		 if (loginContent != null)
			 $('.bottom [by-model="statusLogin"]').text(loginContent).css('text-align', 'center');
		 if (workContent != null)
			 $('.bottom [by-model="statusWork"]').text(workContent).css('text-align', 'center');
		 if (phoneContent != null)
			 $('.bottom [by-model="statusPhone"]').text(phoneContent);
		 if (versionContent != null)
			 $('.bottom [by-model="emptyStatus"]').text(versionContent);
	 },
	 /** 开始计时*/
	 begWriteAskTiem : function (user){
		 // 开始计时
		 $('input[by-model="duration"]').val(user.askTime);
		 this.timeTaskParames.closeTaskParam(user.answerTime);
		 user.answerTime = window.setInterval(function () {
			 var el = $('input[by-model="duration"]'); // 获取 目的标签
			 var v = el.val(); // 获取当前的计时时间
			 if (!v) v = '00:00'; // 给出默认的 时间
			 var array = v.split(':');	// 进行 分钟 和 秒 的区分
			 var s = parseInt(array[1]); 	// 获取 秒
			 var m = parseInt(array[0]);	// 获取 分钟
			 var new_s = s + 1;	// 秒数 +1
			 if (new_s >= 60) {		// 如果秒数 大于 60  也就是超过1分钟  分钟+1
				 new_s = '00';
				 m = m + 1;
			 } else if (new_s < 10) {	// 如果秒数 小于10 秒数前面+0
				 new_s = '0' + new_s;
			 }
			 if (m < 10) {	// 如果分钟小于10  前面+0
				 m = '0' + m;
			 }
			 var new_time = m + ':' + new_s; 	// 新的 计时时间
			 el.val(new_time); 	// 塞值
			 user.askTime = new_time;// 更新通话时长
		 }, 1000);
	 },
	 /** 停止计时  非挂机状态下的停止计时*/
	 endWriteAskTime :function (user){
		 var askTime = user.askTime;
		 this.timeTaskParames.closeTaskParam(user.answerTime);
		 user.answerTime = window.setInterval(function () {
			 var v = askTime; // 获取当前的计时时间
			 if (!v) v = '00:00'; // 给出默认的 时间
			 var array = v.split(':');	// 进行 分钟 和 秒 的区分
			 var s = parseInt(array[1]); 	// 获取 秒
			 var m = parseInt(array[0]);	// 获取 分钟
			 var new_s = s + 1;	// 秒数 +1
			 if (new_s >= 60) {		// 如果秒数 大于 60  也就是超过1分钟  分钟+1
				 new_s = '00';
				 m = m + 1;
			 } else if (new_s < 10) {	// 如果秒数 小于10 秒数前面+0
				 new_s = '0' + new_s;
			 }
			 if (m < 10) {	// 如果分钟小于10  前面+0
				 m = '0' + m;
			 }
			 var new_time = m + ':' + new_s; 	// 新的 计时时间
			 user.askTime = new_time;// 更新通话时长
		 }, 1000);
	 },
	 showACDCallMsg : function (data){
		 $('ul[by-model="waiteList"]').html('');
		 if(data && data.length > 0){
			 // <li ><span class="zj_num">15330219820</span><span class="wt_time">00:00:02</span><span class="acd_num">ACD1</span></li>
			 for(var i = 0;i<data.length;i++){
				 var text = '<li callhd="'+data[i].callhd+'">';
				 text += '<span class="zj_num">'+data[i].caller+'</span>';
				 text += '<span class="wt_time">'+data[i].time+'</span>';
				 text += '<span class="acd_num">'+data[i].acdName+'</span>';
				 text += '</li>';
				 $('ul[by-model="waiteList"]').append(text);
			 }
		 }
		 var that = this;
		 $('ul[by-model="waiteList"] li').dblclick(function(){
			 var callhd = $(this).attr('callhd');
			 that.sendMsgToAgentServer({
				 'msgId': 65,
				 'callhd': callhd,
			 });
		 });
	 },
	 strongConnectCall : function (data){ // 强接 结果
		 var that = this;
		 if(data.status == 0 && this.takingArr.length > 0){ // 强接成功
			 $.each(this.takingArr,function(){
				 that.timeTaskParames.closeTaskParam(this.drawingTime);
				 that.timeTaskParames.closeTaskParam(this.answerTime);
				 that.timeTaskParames.closeTaskParam(this.ringTime);
			 });
			 that.sendMsgToAgentServer({
				 'msgId': 5,
				 'status': that.curLoginUser.AgentStatus
			 });
			 this.setShowAgentStatus(null,null,null, agentVersion);
		 }
	 },
	 /**
	  * 当前坐席配置信息
	  */
	 curLoginUser: {
		 'ServerIP': '',//IPCC Server IP------------------
		 //	'SlaveServerIP' : '',//IPCC Server IP
		 //	'ServerQueueIP' : '',// ACD队列获取IP---------------
		 //	'ServerQueuePort' : '8080', // ACD队列获取端口，默认40005
		 'ServerQueueEnabled': '1',//是否启用ACD队列显示，默认不开启 0
		 'AutoHold': '1',// 是否允许自动保持  0否/1是
		 'GreetingEnable': '1',//欢迎语打开状态 0关闭 1打开
		 'GreetingVisible': '1', // 允许用户启动或者禁用欢迎语
		 'AutoAnswerEnable': '0', // 自动接听打开状态 0关闭 1打开
		 'AutoAnswerVisible': '1',//允许用户启动或者禁用自动接听
		 'TransCallIVR': 'NATIVE_TRANS_TEL', //座席直接转接外部电话用的IVR
		 'InCallHangToIVR': '1',//呼入时，点击挂机按钮，是否转接IVR
		 'InCallHangIVRCode': 'evaluate',// 呼入时，点击挂机按钮，转接的IVR代码
		 'OutCallHangToIVR': '0', //呼出时，点击挂机按钮，是否转接IVR
		 'OutCallHangIVRCode': 'evaluate',//呼出时，点击挂机按钮，转接的IVR代码
		 'PlayRingSound': '1',//是否播放振铃提示音
		 'PlayOutDialSound': '1',// 是否播放外拨提示音
		 'PlayTalkSound': '1',//是否播放通话提示音
		 'PlayHangUpSound': '1',//是否播放挂机提示音
		 'MaxWarpUpTime': '30',//话后处理时间 单位（s）
		 'CodeC': '0', //	 0/G711u 4/G723 8/G711A 18/G729
		 'PTime': '20',//default 20
		 'agentCustName': 'IPCC',//客户名 此项固定
		 'agentUserName': '',//座席工号
		 'agentPassword': '',//座席密码
		 'AutoReconnect': '1',//网络断开后是否自动重新连接
		 'agentSoundType': '',// 放音类型 0 SIP软电话 1 声卡
		 'agentSipNumber': '',//使用 SIP 软电话时电话号码（用于外呼）
		 'InvisiAgentOnInter': '',//内呼时不显示的坐席,如果有多个，以逗号分隔
		 'InvisiAgentOnTransfer': '',//转移时不显示的坐席,如果有多个，以逗号分隔
		 'CallOutAutoWrapUp': '0',//外呼是否自动进入话后模式
		 'AlwaysOffHook': '0',//座席是否启用常摘机模式1是0否
		 'RingTimeOutToACD': '1000,ACDPhone', //振铃超时处理
		 'ExtendAction': '转系统语音:4:8000', //扩展操作定义
		 // 以下为非原始坐席条内容
		 'WebSocketIP': '',// 新agentProxy服务器地址
		 'WebSocketPort': '',// 新agentProxy 服务器端口
		 'Supervisor': '0',// 是否主管 0否 2 是
		 'AgentStatus': '',// 当前坐席状态
		 'AutoAnswer': 0,// 是否自动应答
		 'CkeckOutCase': '',//
		 'webSocketStatus' : '0',
		 'wsTimeout':'60',
		 'wsInterval' : '5',
		 'wsLastRecTime' : null,
		 'wsHeartTimer':null,
		 'strongCheckOut' : false, // 是否强制签出
		 'isHttps' : false, // 是否https请求,
		 'disconnectCallBack' : null,
		 'disconnectReason':''
	 },
	 /**
	  * 坐席初始化
	  */
	 init: function () {//初始化 websocket,同时签入
		 var that = this;
		 var agent = that.curLoginUser;
		 console.info(agent);
		 if (!agent.WebSocketIP || agent.WebSocketIP == '') {
			 that.promptBox('提示','please configure agent server IP !');
			 return;
		 } else if (!agent.WebSocketPort || agent.WebSocketPort == '') {
			 that.promptBox('提示','please configure agent server port !');
			 return;
		 } else if (!agent.ServerIP || agent.ServerIP == '') {
			 that.promptBox('提示','please configure IPCC server IP !');
			 return;
		 } else if (!agent.agentSoundType || agent.agentSoundType == '') {
			 that.promptBox('提示','please configure agent type !');
			 return;
		 } else if (!agent.agentUserName || agent.agentUserName == '') {
			 that.promptBox('提示','please configure agent code !');
			 return;
		 } else if (!agent.agentPassword || agent.agentPassword == '') {
			 that.promptBox('提示','please configure agent password !');
			 return;
		 } else if (!agent.agentSipNumber || agent.agentSipNumber == '') {
			 that.promptBox('提示','please configure agent tel !');
			 return;
		 }
		 // 离席参数 初始化
		 this.leaveData.ckeckStatus = this.constant.login_user_not_cancel_leaveData;
		 this.leaveData.leaveTel = '';
		 // 坐席条所有的按钮 置灰 不可以点击
		 that.btnClickAbles('');
		 // 坐席连接事件   (agent.isHttps ? 'wss://' : 'ws://')
		 var url = 'wss://' + agent.WebSocketIP + ':' + agent.WebSocketPort + '/agent/websocket/'
			 + agent.agentUserName + '/' + agent.agentSoundType + '/?ipccServerIP=' + agent.ServerIP;
 //		var url = 'ws://' + agent.WebSocketIP + ':' + agent.WebSocketPort + '/agent?userCode='+agent.agentUserName+'&ipccServerIP=' + agent.ServerIP;
		 if(that.curLoginUser.disconnectCallBack){
				that.curLoginUser.disconnectCallBack('1','开始登录');
		 }
		 initWebSocket(url);
		 // 绑定 离席 操作框 事件
		 $('#agentCallStatus').on('click', '[by-model="departureMode"]', function () {
			 var ev = $('input[by-model="userNumber"]');
			 var status_model = $(this).prop('checked');
			 agent.CkeckOutCase = that.constant.login_user_leaveData_case;
			 if (status_model) {
				 var tel = ev.val();
				 // 验证纯数字
				 if (!new RegExp('^[0-9]*$').test(tel)) tel = '';
				 if (tel == '') {
					 ev.addClass('input-empty');
					 $(this).prop('checked', false);
				 } else {
					 ev.removeClass('input-empty');
					 that.leaveData.leaveTel = tel;
					 that.sendMsgToAgentServer({'msgId': 9});
					 ev.attr('readonly', 'readonly');
				 }
				 // 非 取消离席
				 that.leaveData.ckeckStatus = that.constant.login_user_not_cancel_leaveData;
			 } else {
				 // 取消 离席
				 that.leaveData.ckeckStatus = that.constant.login_user_cancel_leaveData;
				 that.sendMsgToAgentServer({'msgId': 9});
				 ev.removeAttr('readonly');
			 }
		 });
		 // 关于 欢迎语的操作
		 var welcomCheck = $('#agentCallStatus input[by-model="welSpeech"]');
		 if (that.curLoginUser.GreetingVisible != '1') {
			 welcomCheck.attr("disabled", "disabled");
		 } else {
			 //  可以操作  添加点击事件
			 welcomCheck.on('click', function () {
				 var status = $(this).prop('checked');
				 if (status) {
					 that.sendMsgToAgentServer({'msgId': 7, 'status': 1});
				 } else {
					 that.sendMsgToAgentServer({'msgId': 7, 'status': 0});
				 }
			 });
		 }
		 if (this.curLoginUser.GreetingEnable == '1') { // 欢迎语打开
			 welcomCheck.prop('checked', true);
		 } else if (this.curLoginUser.GreetingEnable == '0') {// 欢迎语关闭
			 welcomCheck.prop('checked', false);
		 }
		 // 关于 用户自动应答的操作
		 var autoAnswerCheck = $('#agentCallStatus input[by-model="autoAnswer"]');
		 if (this.curLoginUser.AutoAnswerVisible != '1' || this.curLoginUser.agentSoundType == 0) {
			 autoAnswerCheck.attr("disabled", "disabled");
		 } else {
			 //  可以操作  添加点击事件
			 autoAnswerCheck.on('click', function () {
				 var status = $(this).prop('checked');
				 if (status) {
					 that.curLoginUser.AutoAnswer = that.constant.call_allow_auto_answer;
				 } else {
					 that.curLoginUser.AutoAnswer = that.constant.call_not_allow_auto_answer;
				 }
			 });
		 }
		 if (this.curLoginUser.AutoAnswerEnable == '1') { // 打开自动 接听
			 autoAnswerCheck.prop('checked', true);
		 } else if (this.curLoginUser.AutoAnswerEnable == '0') {// 关闭自动接听
			 autoAnswerCheck.prop('checked', false);
		 }
		 // 所有的弹出框 中 input框 只允许输入纯数字
		 $('body').on('keyup paste', '.back-g .inputNum', function () {
			 $(this).val($(this).val().replace(/[^0-9*#]/g, ''));
		 });
		 // 所有弹出框 右上角的 X 号、class="cancel-btn" 添加 关闭当前窗口事件
		 $('body').on('click', '.back-g .close-btn,.back-g .cancel-btn', function () {
			 $(this).parents('div[class="back-g"]').remove();
		 });
	 },
	 /**
	  * 修改签入 签出状态的动作
	  * @param checkIn    true：签入，false：签出
	  * @param caseWhy    发生的原因
	  */
	 changeCheckStatusAction: function (checkIn, caseWhy) {
		 if (checkIn) {
			let loginExt = localStorage.getItem('loginExt') ;			//分机号
			rem(".connATC", '分机'+loginExt);
			util.success('呼叫中心服务连接成功！');
			 $('#agentBtnList [by-model="checkIn"]').hide();
			 $('#agentBtnList [by-model="checkOut"]').show();
			 this.setShowAgentStatus('已经签入', this.curLoginUser.agentUserName + ' 正在工作', '您正在等待下一个电话. . . .', agentVersion);
		 } else {
			 $('#agentBtnList [by-model="checkIn"]').show();
			 $('#agentBtnList [by-model="checkOut"]').hide();
			 this.setShowAgentStatus('已经签出', '用户签出', caseWhy ? caseWhy : '', agentVersion);
		 }
	 },
	 /**
	  * 欢迎语 设置 返回
	  * @param data
	  */
	 enableWelcomAction: function (data) {
		 if (data != 0) { // 说明失败  反选
			 $('[by-model="welSpeech"]').prop('checked', !$('[by-model="welSpeech"]').prop('checked'));
		 }
	 },
	 /**
	  * 显示  排队人数 和 在线坐席数
	  * @param data
	  */
	 showWaitAndOnlineNum: function (data) {
		 $('[by-model="lineUp"]').val(data.waitNum);
		 $('[by-model="onLine"]').val(data.onlineNum);
	 },
	 /**
	  * 修改 示闲  示忙（true : 示闲   ，false：示忙） 2019-04-16  qyl
	  * @param status
	  */
	 changeWorkOrRestAction: function (isTaking) {
		 var status = this.curLoginUser.AgentStatus;
		 if (status == '8') {
			 $('#agentBtnList [by-model="showBusy"]').hide();
			 $('#agentBtnList [by-model="showIdle"]').show();
			 if (!isTaking) {
				 this.setShowAgentStatus(null, this.curLoginUser.agentUserName + ' 正在休息', '', null);
			 }
			 onStatusChanged(2);
		 } else if (status == '1') {
			 $('#agentBtnList [by-model="showBusy"]').show();
			 $('#agentBtnList [by-model="showIdle"]').hide();
			 if (!isTaking) {
				 this.setShowAgentStatus(null, this.curLoginUser.agentUserName + ' 正在工作', null, null);
			 }
			 onStatusChanged(1);
		 }
	 },
	 /**
	  *  质检 和 取消质检 进行切换
	  * @param isQuality true 开始质检   false  取消质检
	  * @param result true 执行成功  false  执行失败
	  * @param showContent	坐席条状态栏显示的信息
	  * @param changeQuality 是否在 质检和取消按钮 质检切换
	  */
	 changeQualityAction:function(isQuality,result,showContent,changeQuality){
		 // 判断执行 结果
		 var that = this;
		 if(result){ // 执行 成功
			 if(isQuality){ // 执行开始质检
				 if(changeQuality){
					 $('#agentBtnList [by-model="qualityTesting"]').hide();
					 $('#agentBtnList [by-model="qualityTestingCancel"]').show();
				 }
				 that.setShowAgentStatus(null,null,showContent+this.qualityUserCode+'成功',null);
			 }else{ // 执行取消质检
				 if(changeQuality){
					 $('#agentBtnList [by-model="qualityTestingCancel"]').hide();
					 $('#agentBtnList [by-model="qualityTesting"]').show();
				 }
				 that.setShowAgentStatus(null,null,showContent+this.qualityUserCode+'成功',null);
				 setTimeout(function(){
					 that.setShowAgentStatus(
						 that.begoreQualityPageUserStatus.loginContent,
						 that.begoreQualityPageUserStatus.workContent,
						 that.begoreQualityPageUserStatus.phoneContent,
						 that.begoreQualityPageUserStatus.versionContent);
				 },500);
			 }
		 }else{ // 执行失败
			 that.setShowAgentStatus(null,null,showContent+this.qualityUserCode+'失败',null);
			 if(isQuality){ // 执行开始质检
				 setTimeout(function(){
					 that.setShowAgentStatus(
						 that.begoreQualityPageUserStatus.loginContent,
						 that.begoreQualityPageUserStatus.workContent,
						 that.begoreQualityPageUserStatus.phoneContent,
						 that.begoreQualityPageUserStatus.versionContent);
				 },500);
			 }else{ // 执行取消质检
				 setTimeout(function(){
					 that.setShowAgentStatus(
						 that.afterQualityPageSuccessStatus.loginContent,
						 that.afterQualityPageSuccessStatus.workContent,
						 that.afterQualityPageSuccessStatus.phoneContent,
						 that.afterQualityPageSuccessStatus.versionContent);
				 },500);
			 }
		 }
	 },
	 /**
	  * 通话的数组
	  */
	 takingArr: [],// 当前正在通话的信息
	 /**
	  * 来电 进入  接收信息msgID  31
	  * 操作：保留 当前来电信息
	  * @param data
	  */
	 incomingCall: function (data) {
		 //[31,IPCC,104,0x65010e52,8007,7000,10.10.10.250,20066,0,ACD3,0,,,20,,1354]
		 var call = {
			 'caller': data.caller, // 主叫
			 'callId': data.callId,// 通话ID  16进制的数据
			 'called': data.called,// 被叫
			 'acdData': data.acdData,// 随路数据
			 'sessionId': data.sessionId,// 通话ID  cdr_id
			 'takingStatus': this.constant.call_user_accessing, //  通话状态  进入、振铃、应答...等
			 'callStatus': this.constant.call_user_in_side,// 呼叫状态  热线 呼入、内呼
			 'isUsed': this.constant.call_user_taking,// 通话是否占用，
			 'ringTime': 0,
			 'answerTime': 0,
			 'drawingTime': 0,
			 'askTime': '00:00',
			 'transfer': false,
			 'wrapUp':1,
		 };
		 this.takingArr.push(call);
	 },
	 /**
	  * 振铃请求 接收信息 msgID 33
	  */
	 onRing: function (data) {
		 var call = {};
		 var that = this;
		 // 这里 直接振铃 说明  非 正常呼叫。。目前收到的 是 强接功能
		 if(this.takingArr.length == 0){

		 }else{
			 $.each(this.takingArr, function () {
				 if (this.isUsed == that.constant.call_user_taking) {
					 call = this;
					 this.takingStatus = that.constant.call_user_ring;
					 return false;
				 }
			 });
			 if (call.callStatus == that.constant.call_user_in_side) { // 呼入
				 that.ringAction(call);
				 // 可以提供 外部方法 调用
				 onRingCall(call);
			 } else {
				 //call.callId = data.callId;
			 }
		 }
	 },
	 /**
	  * 定时器参数
	  */
	 timeTaskParames: {
		 'ringTime': 0,// 振铃事件的参数
		 'answerTime': 0,//通话计时
		 'drawingTime': 0, // 话后计时
		 closeTaskParam: function (time) {
			 window.clearInterval(time);
		 },
		 closeRingTime:function(arr){ // 关闭所有的振铃 计时器
			 var len = arr.length;
			 if(len == 0) return;
			 $.each(arr, function () {
				 window.clearInterval(this.ringTime);
			 });
		 },
	 },
	 /**
	  * 振铃 页面动作
	  */
	 ringAction: function (call) {
		 this.timeTaskParames.closeRingTime(this.takingArr);// 不明白 为什么会推送多次的振铃事件
		 $(".bottom").css("backgroundColor", "red");
		 call.ringTime = window.setInterval(function () {
			 var d = new Date();
			 var s = d.getSeconds();
			 if (s % 2 == 0) {
				 $(".bottom").css("backgroundColor", "red");
			 } else {
				 $(".bottom").css("backgroundColor", "#d1e1ff");
			 }
		 }, 1000);
		 $('.bottom .phone-status').text('正在振铃');
		 $('#agentCallStatus [by-model="phoneNumber"]').val(call.caller);
		 if (this.curLoginUser.autoAnswer == this.constant.call_allow_auto_answer && this.curLoginUser.agentSoundType == 1) { //   如果是声卡坐席  勾选了 自动应答
			 //		this.answer(); 暂时屏蔽
		 }
	 },
	 /**
	  * 服务器推送35 接听结果
	  * @param data
	  */
	 answerAction: function (data) {
		 var that = this;
		 var call;
		 $.each(that.takingArr, function () {
			 if (this.callId == data.callId) {
				 this.takingStatus = that.constant.call_user_answer;
				 if (this.caller == '') this.caller = data.caller;
				 call = this;
			 } else {
				 this.takingStatus = that.constant.call_user_hold; // 将其他的电话至于 等待状态
				 this.isUsed = that.constant.call_user_not_taking;
				 that.endWriteAskTime(this);
			 }
		 });
		 if(!call || call == null){
			 var call = {
				 'caller': data.caller, // 主叫
				 'callId': data.callId,// 通话ID  16进制的数据
				 'called': data.called,// 被叫
				 'acdData': null,// 随路数据
				 'sessionId': null,// 通话ID  cdr_id
				 'takingStatus': this.constant.call_user_answer, //  通话状态  进入、振铃、应答...等
				 'callStatus': null,// 呼叫状态  热线 呼入、内呼
				 'isUsed': this.constant.call_user_taking,// 通话是否占用，
				 'ringTime': 0,
				 'answerTime': 0,
				 'drawingTime': 0,
				 'askTime': '00:00',
				 'transfer': false,
				 'wrapUp':1,
			 };
			 this.takingArr.push(call);
		 }
		 call.wrapUp = data.wrapUp;// 是否有话后  0 没有  1 有
		 that.setShowAgentStatus(null, null, '正在通话', null);
		 $(".bottom").css("backgroundColor", "#d1e1ff");
		 that.timeTaskParames.closeRingTime(that.takingArr); // 清除振铃的定时器
		 if (call.transfer) {
			 //  发送 转接请求
			 that.sendMsgToAgentServer({
				 'msgId': 77,
				 'agentCode': call.called,
				 'customerTakingId': that.curTakingId,
			 });
			 // 移除当前通话
			 this.threadDrawingAction({'callId': call.callId});
			 return;
		 }
		 that.begWriteAskTiem(call);
		 // 调用外部方法
		 if( call.callId != 0x00000000){
			 if(call.callStatus == that.constant.call_user_out_side){
				 // 外呼
				 onCalloutAnswered(call);
			 }else{
				 onCallAnswered(call);
			 }
		 }else{
			 // 内呼
		 }
	 },

	 /**
	  * 挂机返回
	  * @param data
	  * @param flag true 非坐席条请求挂机
	  */
	 threadDrawingAction: function (data,flag) {
		 // 挂机 触发条件
		 onCallReleased();
		 $(".bottom").css("backgroundColor", "#d1e1ff");
		 var that = this;
		 var releaseCall;
		 // 根据通话ID 查找 该路通话
		 $.each(this.takingArr, function () {
			 if (this.callId == data.callId) {
				 releaseCall = this;
				 return false;
			 }
		 });
		 // 如果没有找到对应的通话  则找当前正在通话的 数据
		 if(!releaseCall || releaseCall == null){
			 $.each(that.takingArr,function(){
				 if (this.isUsed == that.constant.call_user_taking) {
					 releaseCall = this;
					 return false;
				 }
			 });
		 }
		 //  没有通话 那么根据 是否从经 外呼 或者 内呼 保存的通话ID
		 if((!releaseCall || releaseCall == null) && this.curTakingId != 0){
			 $.each(this.takingArr, function () {
				 if (this.callId == that.curTakingId) {
					 releaseCall = this;
					 return false;
				 }
			 });
		 }
		 if(releaseCall && releaseCall.answerTime){
			 this.timeTaskParames.closeTaskParam(releaseCall.answerTime);
		 }
		 // 这里挂机 需要判断下  是否是三方通话中 第一次挂机
		 if(!flag && this.threePartyArr.length > 1){
			 return;
		 }

		 var showAfterTaking = true;
		 var showText = '';
		 if(!releaseCall || releaseCall == null){
			 that.afterSpeech();
			 return;
		 }

		 if (releaseCall.callStatus == this.constant.call_user_in_side) {
			 if (releaseCall.takingStatus == this.constant.call_user_ring) {
				 showAfterTaking = false;
				 showText = '未被接听';
			 } else {
				 showText = status == 200 ? '对方挂断' : '通话完毕';
			 }
		 } else {
			 if (releaseCall.takingStatus == this.constant.call_user_answer || releaseCall.takingStatus == this.constant.call_user_hold) {
				 if (this.curLoginUser.OutCallHangToIVR == '1') {
					 showText = status == 200 ? '对方挂断' : '通话完毕';
				 } else {
					 showAfterTaking = false;
					 showText = '通话结束';
				 }
			 } else {
				 showAfterTaking = false;
				 showText = '未被接听';
			 }
		 }
		 releaseCall.takingStatus = that.constant.call_user_release;
		 if (showAfterTaking) {
			 if(releaseCall.wrapUp == 1){ // 自动进入话后，计算话后时长
				 that.setShowAgentStatus(null, null, showText, '话后剩余：' + this.curLoginUser.MaxWarpUpTime);
				 releaseCall.drawingTime = window.setInterval(function () {
					 var el = $('.bottom [by-model="emptyStatus"]');
					 var time = parseInt(el.text().replace('话后剩余：', ''));
					 if (time == 0) {
						 that.afterSpeech();
					 } else {
						 el.text('话后剩余：' + (time - 1));
					 }
				 }, 1000);
			 }else{
				 that.afterSpeech();
			 }
		 } else {
			 this.setShowAgentStatus(null, null, showText, null);
			 that.afterSpeech();
		 }
	 },
	 /**
	  * 请求保持返回
	  */
	 keepAction: function (data) {
		 if (data.code == 0) { //
			 var that = this;
			 var keepCall;
			 $.each(this.takingArr, function () {
				 if (data.callId == this.callId) {
					 this.takingStatus == that.constant.call_user_hold;
					 keepCall = this;
					 return false;
				 }
			 });
			 $('[by-model="keep"]').hide();
			 $('[by-model="unkeep"]').show();
			 this.setShowAgentStatus(null, null, '通话保持', null);
		 } else {
			 this.setShowAgentStatus(null, null, data.msg, null);
		 }
	 },
	 /**
	  * 请求签入
	  */
	 checkIn: function (autoCheckIn) {
		 // 这里需要 判断 是否是离席 模式
		 var leaveStatus = this.leaveData.ckeckStatus;
		 if (leaveStatus == this.constant.login_user_not_cancel_leaveData) {// 离席模式
			 this.sendMsgToAgentServer({'msgId': 1, 'userNumber': this.leaveData.leaveTel});
		 } else {
			 this.sendMsgToAgentServer({'msgId': 1});
		 }
		 this.sendMsgToAgentServer({'msgId': 5, 'status': 8});
		 if(!autoCheckIn){
			 this.sendMsgToAgentServer({'msgId': 7, 'status': 1});
		 }
		 //this.sendMsgToAgentServer({'msgId': 5, 'status': 1});
		 //签入操作
		 onLoginSucc();
	 },
	 /**
	  * 取消 通话保持 返回
	  */
	 unkeepAction: function (data) {
		 if (data.code == 0) { //
			 var that = this;
			 $.each(this.takingArr, function () {
				 if (data.callId == this.callId) {
					 this.takingStatus == that.constant.call_user_answer;
					 return false;
				 }
			 });
			 $('[by-model="unkeep"]').hide();
			 $('[by-model="keep"]').show();
			 this.setShowAgentStatus(null, null, '通话恢复', null);
		 } else {
			 this.setShowAgentStatus(null, null, data.msg, null);
		 }
	 },
	 /**
	  * 外呼 结果返回
	  * [38,IPCC,106,0x23233,0,]
	  * @param data
	  */
	 outCallAction: function (data) {
		 if (data.status == 0) {
			 var that = this;
			 $.each(that.takingArr, function () {
				 if (this.takingStatus == that.constant.call_user_not_use) {
					 this.isUsed = that.constant.call_user_taking;
					 this.callId = data.callId;
					 this.sessionId = data.sessionId;
					 that.begWriteAskTiem(this);
				 } else {
					 this.isUsed = that.constant.call_user_not_taking;
					 that.endWriteAskTime(this);
				 }
			 });
		 }
	 },
	 /**
	  * 内呼请求回应 返回的是 在线坐席的信息
	  * @param data
	  */
	 inboundAction: function (data) {
		 this.createInCallAgentPage(data, false);
	 },
	 /**
	  * 转坐席
	  * @param data
	  */
	 transferAgentAction: function (data) {
		 this.createInCallAgentPage(data, true);
	 },
	 /**
	  * 请求 释放转   回应
	  * @param data
	  */
	 releaseTurnAction: function(data){
		 this.createShowIVRPage(data,false);
	 },
	 /**
	  * 请求 挂起转  回应
	  * @param data
	  */
	 hangUpAction : function(data){
		 this.createShowIVRPage(data,true);
	 },
	 /**
	  * 转IVR 页面
	  * @param ivrs 展示IVR 信息
	  * @param hold 是否需要挂起
	  */
	 createShowIVRPage:function(ivrs,hold){
		 var that = this;
		 var call;
		 $.each(that.takingArr,function(){
			 if(this.isUsed == that.constant.call_user_taking
				 && (this.takingStatus == that.constant.call_user_answer || this.takingStatus == that.constant.call_user_hold)){
				 call = this;
				 return false;
			 }
		 });
		 var html = '<div class="back-g">'
			 + '<div class="show-msg">'
			 + '<div class="title">选择IVR<span class="close-btn">×</span></div>'
			 + '<div class="release-trun-ivr">'
			 + '<div class="chose-ivr-title">选择IVR</div>'
			 + '<div class="online-ivr">';
		 if(ivrs.length > 0){
			 html += '<table callId="'+call.callId+'" callSessionId="'+call.sessionId+'">';
			 for (var i = 0;i<ivrs.length;i++){
				 var ivrMsg = ivrs[i];
				 html += '<tr ivrmsg="'+ivrMsg+'"><td>'+ivrMsg+'</td></tr>';
			 }
			 html += '</table>';
		 }
		 html += '</div>'
			 + '<div class="ivr-btn-group">'
			 + '<input class="ivr-btn" type="button" value="确定" />'
			 + '<input class="cancel-btn" type="button" value="取消" />'
			 + '</div></div></div></div>';
		 $('body').append(html);
		 // 需要添加 点击事件
		 $('.back-g .online-ivr table tr').click(function () {
			 $(this).addClass('color-tr-chosed');
			 $(this).siblings().removeClass('color-tr-chosed');
		 });
		 $('.back-g .ivr-btn').click(function () {
			 var ivrMsg,callId=$('.online-ivr table').attr('callId'),sessionId=$('.online-ivr table').attr('callSessionId');
			 $('.back-g .online-ivr table tr').each(function () {
				 var cls = $(this).attr('class');
				 if (cls && cls.indexOf('color-tr-chosed') >= 0) {
					 ivrMsg = $(this).attr('ivrMsg');
					 return false;
				 }
			 });
			 if(!hold){
				 that.sendMsgToAgentServer({
					 'msgId': 67,
					 'callId': callId,
					 'agentInfo': 'ACD(' + sessionId + ')',
					 'ivrName': ivrMsg,
				 });
			 }else{
				 that.sendMsgToAgentServer({
					'msgId' : 101,
					'callId' : callId,
					'ivrName' : ivrMsg,
					'sessionId' : sessionId,
				 });
			 }
			 $('.back-g').remove();
		 });
		 $('.back-g .online-ivr table tr').dblclick(function () {
			 $('.back-g .ivr-btn').click();
		 });
	 },
	 /**
	  * 转 ACD 请求 回应
	  * @param data
	  */
	 turnACDAction : function(data){
		 var that = this;
		 var call;
		 $.each(that.takingArr,function(){
			 if(this.isUsed == that.constant.call_user_taking
				 && (this.takingStatus == that.constant.call_user_answer || this.takingStatus == that.constant.call_user_hold)){
				 call = this;
				 return false;
			 }
		 });
		 var html = '<div class="back-g">'
			 + '<div class="show-msg">'
			 + '<div class="title">选择ACD<span class="close-btn">×</span></div>'
			 + '<div class="trun-acd">'
			 + '<div class="chose-acd-title">选择ACD</div>'
			 + '<div class="online-acd">';
		 if(data.length > 0){
			 html += '<table callId="'+call.callId+'" callSessionId="'+call.sessionId+'">';
			 for (var i = 0;i<data.length;i++){
				 var acdMsg = data[i];
				 html += '<tr acdmsg="'+acdMsg+'"><td>'+acdMsg+'</td></tr>';
			 }
			 html += '</table>';
		 }
		 html += '</div>'
			 + '<div class="acd-btn-group">'
			 + '<input class="acd-btn" type="button" value="确定" />'
			 + '<input class="cancel-btn" type="button" value="取消" />'
			 + '</div></div></div></div>';
		 $('body').append(html);
		 // 需要添加 点击事件
		 $('.back-g .online-acd table tr').click(function () {
			 $(this).addClass('color-tr-chosed');
			 $(this).siblings().removeClass('color-tr-chosed');
		 });
		 $('.back-g .acd-btn').click(function () {
			 var acdMsg,callId=$('.online-acd table').attr('callId');
			 $('.back-g .online-acd table tr').each(function () {
				 var cls = $(this).attr('class');
				 if (cls && cls.indexOf('color-tr-chosed') >= 0) {
					 acdMsg = $(this).attr('acdMsg');
					 return false;
				 }
			 });
			 that.sendMsgToAgentServer({
				 'msgId' : 71,
				 'callId' : callId,
				 'acdName' : acdMsg,
				 'lastIndex':99,
			 });
			 $('.back-g').remove();
		 });
		 $('.back-g .online-acd table tr').dblclick(function () {
			 $('.back-g .acd-btn').click();
		 });
	 },
	 /**
	  * 创建 内呼坐席 页面
	  * @param agents 获取的坐席信息
	  * @param transfer 是否转移
	  */
	 createInCallAgentPage: function (agents, transfer) {
		let personMap = new Map();
        let  callThinkAdminList = localStorage.getItem(`callThinkAdminList`);
        let jsonObj = JSON.parse(callThinkAdminList);
        for (const key of Object.keys(jsonObj)) {
          personMap.set(key, jsonObj[key]);
        }
		 var that = this;
		 var html = '<div class="back-g">'
			 + '<div class="show-msg">'
			 + '<div class="title">选择坐席<span class="close-btn">×</span></div>'
			 + '<div class="inbound-call">'
			 + '<div class="chose-agent-title">选择坐席</div>'
			 + '<div class="online-agent">';
		 if (agents.length > 0) {
			 html += '<table>';
			 for (var i = 0; i < agents.length; i++) {
				 var agentType = agents[i].userStatus;
				 var img = './agentProxy/icon/';
				 if (agentType < 10) {
					 img += agentType + '-10' + agentType + '.png';
				 } else if (agentType >= 10 && agentType < 100) {
					 img += agentType + '-1' + agentType + '.png';
				 } else if (agentType >= 100 && agentType < 200) {
					 img += (agentType - 100) + '-' + agentType + '.png';
				 }
				 if(agentType == 1){       //空闲
					img = 'https://ygdjonline.com/ywxt/image/20230829/1-101.png';
				 }else if(agentType == 8){  //忙碌
					img = 'https://ygdjonline.com/ywxt/image/20230829/8-108.png';
				 }
				 //html += '<tr userCode="' + agents[i].userCode + '"><td><img src="' + img + '"/></td><td>' + agents[i].userName + '(' + agents[i].userCode + ')</td></tr>';
				html += '<tr userCode="' + agents[i].userCode + '"><td><img src="' + img + '"/></td><td>' + personMap.get(agents[i].userName+'') + '(' + agents[i].userCode + ')</td></tr>';
			 }
			 html += '</table>';
		 }
		 html += '</div>'
			 + '<div class="inbound-btn-group">'
			 + '<input class="inbound-btn" type="button" value="确定" />'
			 + '<input class="cancel-btn" type="button" value="取消" />'
			 + '</div></div></div></div>';
		 $('body').append(html);
		 // 需要添加 点击事件  每行   内呼确认事件
		 $('.back-g .online-agent table tr').click(function () {
			 $(this).find('td:not(:first)').addClass('color-tr-chosed');
			 $(this).siblings().find('td:not(:first)').removeClass('color-tr-chosed');
		 });
		 $('.back-g .inbound-btn').click(function () {
			 var called = '';
			 $('.back-g .online-agent table tr').each(function () {
				 var cls = $(this).find('td:nth-child(2)').attr('class');
				 if (cls && cls.indexOf('color-tr-chosed') >= 0) {
					 called = $(this).attr('userCode');
					 return false;
				 }
			 });
			 if (called != '') {
				 var newCall = {
					 'caller': '',
					 'called': called,
					 'takingStatus': that.constant.call_user_not_use,
					 'callStatus': that.constant.call_user_out_side,
					 'isInbound': 1,
					 'ringTime': 0,
					 'answerTime': 0,
					 'drawingTime': 0,
					 'askTime': '00:00',
					 'transfer': transfer,
				 };
				 that.takingArr.push(newCall);
				 if (transfer) {
					 that.sendMsgToAgentServer({
						 'msgId': 37,
						 'called': called,
						 'callType': 1,
						 'transfer': 1,
					 });
				 } else {
					 that.sendMsgToAgentServer({
						 'msgId': 37,
						 'called': called,
						 'callType': 1,
						 'transfer': 0,
					 });
				 }
				 $('#agentCallStatus [by-model="phoneNumber"]').val(called);
				 $('.back-g').remove();
			 }
		 });

		 $('.back-g .online-agent table tr').dblclick(function () {
			 $('.back-g .inbound-btn').click();
		 });
	 },
	 threePartyArr: [],
	 /**
	  * 三方请求应答
	  * @param data
	  */
	 threePartyAction: function (data) {

	 },
	 /**
	  * 挂机 唤醒另外一路通话
	  * @param data
	  */
	 awakenOtherCallAction: function (data) {
		 var that = this;
		 var callUpCallId = data.callId;
		 var realeaseCallId;
		 if(this.threePartyArr.length>0){ // 如果存在三方会议  清空会议
			 $.each(that.threePartyArr,function(){
				 if(this != callUpCallId){
					 realeaseCallId = this;
					 return false;
				 }
			 });
			 this.threePartyArr.splice(0);
		 }
 //		this.sendMsgToAgentServer({
 //			'msgId': 83,
 //			'callId': callUpCallId,
 //		});
		 // 移除 挂机方
		 var i = 0;
		 var j = 0;
		 $.each(that.takingArr,function(){
			 if(this.callId == callUpCallId){
				 this.isUsed = that.constant.call_user_taking;
				 this.takingStatus = that.constant.call_user_answer;
				 that.begWriteAskTiem(this);
			 }else if(this.callId == realeaseCallId && realeaseCallId){
				 j = i;
				 that.timeTaskParames.closeTaskParam(this.drawingTime);
				 that.timeTaskParames.closeTaskParam(this.answerTime);
				 that.timeTaskParames.closeTaskParam(this.ringTime);
				 that.endWriteAskTime(this);
			 }
			 i ++;
		 });
		 that.takingArr.splice(j, 1);
	 },
	 /**
	  * 质检 请求返回
	  * @param data 在线做下
	  */
	 qualityTestingAction : function(data){
		 var that = this;
		 var html = '<div class="back-g">'
			 + '<div class="show-msg quality">'
			 + '<div class="title">服务坐席<span class="close-btn">×</span></div>'
			 + '<div class="quality-call">'
			 + '<div class="chose-agent-title">请选择要操作的坐席</div>'
			 + '<div class="online-agent">'
			 + '<select class="online-agent-select">';
		 if (data.length > 0) {
			 for (var i = 0; i < data.length; i++) {
				 var agent = data[i];
				 html += '<option value="'+agent.custName+'-'+agent.userCode+'">'+agent.userCode+'</option>';
			 }
		 }
		 html += '</select></div>';
		 html += '<div class="action-options">'
			 +'<div class="options-title">操作选项</div>'
			 +'<table><tr>'
			 +'<td><input id="monitor" type="radio" name="option" value="107" checked /><label for="monitor">监听</label></td>'
			 +'<td><input id="intercept" type="radio" name="option" value="47" /><label for="intercept">拦截</label></td>'
			 +'<td><input id="interruption" type="radio" name="option" value="105" /><label for="interruption">插话</label></td>'
			 +'</tr>'
			 +'<tr>'
			 +'<td><input id="strongConnection" type="radio" name="option" value="63" /><label for="strongConnection">强接</label></td>'
			 +'<td><input id="forcedDemolition" type="radio" name="option" value="51" /><label for="forcedDemolition">强拆</label></td>'
			 +'<td></td>'
			 +'</tr>'
			 +'<tr>'
			 +'<td><input id="forceRest" type="radio" name="option" value="61-1" /><label for="forceRest">强制示闲</label></td>'
			 +'<td><input id="forceBusy" type="radio" name="option" value="61-8" /><label for="forceBusy">强制示忙</label></td>'
			 +'<td><input id="forceLogOut" type="radio" name="option" value="59" /><label for="forceLogOut">强制签出</label></td>'
			 +'</tr>'
			 +'</table></div>';
		 html += '<div class="quality-btn-group">'
			 + '<input class="quality-btn" type="button" value="确定" />'
			 + '<input class="cancel-btn" type="button" value="取消" />'
			 + '</div></div></div></div>';
		 $('body').append(html);
		 $('.back-g .quality-btn').click(function () {
			 var userMsg = $('.back-g .online-agent .online-agent-select').val();
			 var option = $('.back-g .action-options input[name="option"]:checked').val();
			 if(userMsg == '') return;
			 // 需要操作坐席 属于的 客户
			 var userCus = userMsg.split('-')[0];
			 // 坐席工号
			 var userCode = userMsg.split('-')[1];
			 // 消息ID
			 var msgId = option.split('-')[0];
			 // 更改的状态
			 var status = option.split('-').length > 1? option.split('-')[1]:null;
			 that.qualityUserCode = userCode;
			 that.begoreQualityPageUserStatus = that.getShowAgentStatus();
			 that.sendMsgToAgentServer({
				 'msgId':msgId,
				 'targetCus' :userCus,
				 'targetUserCode' : userCode,
				 'status' : status,
			 });
			 $('.back-g').remove();
		 });
	 },
	 /**
	  * 质检操作返回
	  * @param data 返回的数据
	  * @param quality 是否质检 true 请求质检  false 取消质检
	   * @param desc 当前操作的描述  如：监听、拦截、强接等
	  */
	 qualityTestingACKAction:function(data,quality,desc){
		 var msgId = Number(data.msgId);
		 var actionResult = data.status == 0 ? true : false;
		 console.info('质检操作项：'+desc+'返回。。。。。');
		 var changeQuality = false;
		 if(actionResult){
			 switch (msgId) {
				 case 48:// 拦截 成功 将外呼、内呼按钮功能屏蔽
					 this.btnClickAblesMusic(['inbound','outbound']);
					 this.qualityNextStepMsg = {'msgId' : 49};
					 changeQuality = true;
					 break;
				 case 50:// 取消拦截 成功  增加 外呼、内呼 按钮功能
					 this.btnClickAblesAdd(['inbound','outbound']);
					 this.qualityNextStepMsg = null;
					 changeQuality = true;
					 break;
				 case 52:
					 break;
				 case 60:
					 break;
				 case 62: // 强制 改变其他人状态
					 break;
				 case 64:
					 break;
				 case 106:
					 break;
				 case 108:  // 监听 成功 将外呼、内呼按钮功能屏蔽
					 this.btnClickAblesMusic(['inbound','outbound']);
					 this.qualityNextStepMsg = {'msgId' : 109};
					 changeQuality = true;
					 break;
				 case 110: // 取消监听 成功  增加 外呼、内呼 按钮功能
					 this.btnClickAblesAdd(['inbound','outbound']);
					 this.qualityNextStepMsg = null;
					 changeQuality = true;
					 break;
			 }
		 }
		 this.changeQualityAction(quality,actionResult,desc,changeQuality);
	 },
	 /**被内呼 msgId:37  回复38，35*/
	 internalCallAction : function (data){
		 this.sendMsgToAgentServer({'msgId':38,'callId':0x00000000});
		 this.sendMsgToAgentServer({
				 'msgId':35,
				 'callId':'0x00000000',
				 'caller':data.caller,
				 'called':data.called,
				 'callerIp':data.callerIp,
				 'callerPort':data.callerPort
				 });
	 },
	 /** 通话转移过来*/
	 transferCallAction : function (data){
		 var call = {
				 'caller': data.caller, // 主叫
				 'callId': data.callId,// 通话ID  16进制的数据
				 'called': data.called,// 被叫
				 'acdData': data.acdData,// 随路数据
				 'sessionId': data.sessionId,// 通话ID  cdr_id
				 'takingStatus': this.constant.call_user_answer, //  通话状态  进入、振铃、应答...等
				 'callStatus': this.constant.call_user_in_side,// 呼叫状态  热线 呼入、内呼
				 'isUsed': this.constant.call_user_taking,// 通话是否占用，
				 'ringTime': 0,
				 'answerTime': 0,
				 'drawingTime': 0,
				 'askTime': '00:00',
				 'transfer': false,
				 'wrapUp':data.wrapUp,
			 };
			 this.takingArr.push(call);
			 this.setShowAgentStatus(null, null, '正在通话', null);
			 $(".bottom").css("backgroundColor", "#d1e1ff");
			 this.timeTaskParames.closeTaskParam(call.ringTime); // 清除振铃的定时器
			 // 开始计时
			 $('input[by-model="duration"]').val(call.askTime);
			 call.answerTime = window.setInterval(function () {
				 var el = $('input[by-model="duration"]'); // 获取 目的标签
				 var v = el.val(); // 获取当前的计时时间
				 if (!v) v = '00:00'; // 给出默认的 时间
				 var array = v.split(':');	// 进行 分钟 和 秒 的区分
				 var s = parseInt(array[1]); 	// 获取 秒
				 var m = parseInt(array[0]);	// 获取 分钟
				 var new_s = s + 1;	// 秒数 +1
				 if (new_s >= 60) {		// 如果秒数 大于 60  也就是超过1分钟  分钟+1
					 new_s = '00';
					 m = m + 1;
				 } else if (new_s < 10) {	// 如果秒数 小于10 秒数前面+0
					 new_s = '0' + new_s;
				 }
				 if (m < 10) {	// 如果分钟小于10  前面+0
					 m = '0' + m;
				 }
				 var new_time = m + ':' + new_s; 	// 新的 计时时间
				 el.val(new_time); 	// 塞值
				 call.askTime = new_time;// 更新通话时长
			 }, 1000);
			 // 调用外部 方法
			 onTransferIn(call);
	 },
	 /********页面主动操作部分********************************************************************************************/
	 /**
	  * 启用 或者取消 欢迎语
	  * @param status true 启用   false  取消
	  */
	 enableWelcom: function (status) {
		 if (status) {
			 this.sendMsgToAgentServer({'msgId': 7, 'status': 1});
		 } else {
			 this.sendMsgToAgentServer({'msgId': 7, 'status': 0});
		 }
	 },
	 /**
	  * 离席操作  签出的时候 agentProxy会返回msgId为10的信息
	  * @param ck  当前的CheckBox
	  * @param status 选择离席 还是 取消离席
	  * @param ev 选择离席时 输入的号码
	  */
	 leaveAgentModel: function (status, ev) { // 离席模式 status  取消离席(false)  还是 选择 离席（true）  ev:离席号码
		 if (status) {
			 var tel = ev.val();
			 // 验证纯数字
			 if (!new RegExp('^[0-9]*$').test(tel)) tel = '';
			 if (tel == '') {
				 ev.addClass('input-empty');
				 ev.prev().prev().prop('checked', false);
			 } else {
				 ev.removeClass('input-empty');
				 this.leaveData.leaveModel = 1;
				 this.leaveData.leaveTel = tel;
				 that.sendMsgToAgentServer({'msgId': 9});
			 }
		 } else {
			 this.leaveData.leaveModel = 2;
			 that.sendMsgToAgentServer({'msgId': 9});
		 }
	 },
	 /**
	  * 请求签出
	  * @param status
	  */
	 checkOut: function () {
		 this.curLoginUser.CkeckOutCase = '';
		 this.sendMsgToAgentServer({'msgId': 9});
		 // 签出调用
		 onLogout();
	 },
	 /**
	  *请求 示忙
	  */
	 showBusy: function () { //
		 this.sendMsgToAgentServer({'msgId': 5, 'status': 8});//示忙
	 },
	 /**
	  * 请求示闲
	  */
	 showIdle: function () {
		 this.sendMsgToAgentServer({'msgId': 5, 'status': 1});
	 },
	 /**
	  * 请求应答
	  */
	 answer: function () {
	 },
	 /**
	  * 请求挂线
	  */
	 threadDrawing: function () {
		 var that = this;
		 //  遍历 查询当前有效的通话
		 if(that.threePartyArr.length > 0){
			 // 三方 会议中 主动挂机
			 var curCall = that.threePartyArr[that.threePartyArr.length-1];
			 //that.threePartyArr.splice(0); // 清空 三方会议数组
			 that.sendMsgToAgentServer({
				 'msgId' : 39,
				 'callId' :curCall,
				 'causeValue': 200,
			 });
		 }else{
			 var curCall = {};
			 $.each(this.takingArr, function () {
				 // 被占用的 通话
				 if (this.isUsed == that.constant.call_user_taking) {
					 curCall = this;
					 return false;
				 }
			 });
			 if (curCall.callStatus == this.constant.call_user_in_side) { // 呼入
				 if (curCall.takingStatus == this.constant.call_user_ring) {
					 that.sendMsgToAgentServer({
						 'msgId': 97,
						 'callId': curCall.callId,
						 'rejectFlag': 0,
					 });
				 } else {
					 if (this.curLoginUser.InCallHangToIVR == '0') { // 呼入 挂断不转接Ivr
						 that.sendMsgToAgentServer({
							 'msgId': 39,
							 'callId': curCall.callId,
							 'causeValue': 200,
						 });
					 } else {
						 that.sendMsgToAgentServer({
							 'msgId': 67,
							 'caller': curCall.caller,
							 'callId': curCall.callId,
							 'called': curCall.called,
							 'agentInfo': 'ACD(' + curCall.sessionId + ')',
							 'ivrName': this.curLoginUser.InCallHangIVRCode,
						 });
					 }
				 }
			 } else { // 呼出
				 // 这个说明电话 已经被接听
				 if (curCall.takingStatus == this.constant.call_user_answer || curCall.takingStatus == this.constant.call_user_hold) {
					 if (this.curLoginUser.OutCallHangToIVR == '0') {
						 that.sendMsgToAgentServer({
							 'msgId': 39,
							 'callId': curCall.callId,
							 'causeValue': 200,
						 });
					 } else {
						 that.sendMsgToAgentServer({
							 'msgId': 67,
							 'caller': curCall.caller,
							 'callId': curCall.callId,
							 'called': curCall.called,
							 'agentInfo': 'ACD(' + curCall.sessionId + ')',
							 'ivrName': this.curLoginUser.OutCallHangIVRCode,
						 });
					 }
				 } else {
					 // 直接发送挂机请求
					 that.sendMsgToAgentServer({
						 'msgId': 39,
						 'callId': curCall.callId,
						 'causeValue': 200,
					 });
				 }
			 }
		 }

	 },
	 /**
	  * 请求 通话保持
	  */
	 keep: function () {
		 var callId = 0;
		 var that = this;
		 //  遍历 查询当前有效的通话
		 $.each(this.takingArr, function () {
			 if (this.isUsed == that.constant.call_user_taking) {
				 callId = this.callId;
				 return false;
			 }
		 });
		 that.sendMsgToAgentServer({
			 'msgId': 81,
			 'callId': callId,
		 });
	 },
	 /**
	  * 请求 取消通话保持
	  */
	 unkeep: function () {
		 var callId = 0;
		 var that = this;
		 //  遍历 查询当前有效的通话
		 $.each(this.takingArr, function () {
			 if (this.isUsed == that.constant.call_user_taking) {
				 callId = this.callId;
				 return false;
			 }
		 });
		 that.sendMsgToAgentServer({
			 'msgId': 83,
			 'callId': callId,
		 });
	 },
	 /**
	  * 请求话后
	  */
	 afterSpeech: function (data) {
		 var that = this;
		 if (!data) {
			 that.sendMsgToAgentServer({
				 'msgId': 5,
				 'status': this.curLoginUser.AgentStatus
			 });
		 }
		 var releaseCall;
		 var i = 0;
		 $.each(that.takingArr, function () {
			 if (this.takingStatus == that.constant.call_user_release) {
				 releaseCall = this;
				 return false;
			 }
			 i++;
		 });
		 if (releaseCall) {
			 this.timeTaskParames.closeTaskParam(releaseCall.drawingTime);
			 this.timeTaskParames.closeTaskParam(releaseCall.answerTime);
			 this.timeTaskParames.closeTaskParam(releaseCall.ringTime);
			 // 这里需要坐下判断 如果是三方会议 且第三方为外呼出去，那么挂机的时候 就直接挂断所有的通话
			 var j = -1;
			 if(releaseCall.callout && that.threePartyArr.length > 1){
				 var incallId = that.threePartyArr[0];
				 $.each(that.takingArr,function(){
					 if(this.callId == incallId){
						 j++;
						 that.timeTaskParames.closeTaskParam(this.drawingTime);
						 that.timeTaskParames.closeTaskParam(this.answerTime);
						 that.timeTaskParames.closeTaskParam(this.ringTime);
						 return false;
					 }
					 j++;
				 });
				 that.threePartyArr.splice(0);
				 that.curTakingId = 0;
			 }else if(that.threePartyArr.length > 1){ // 通过软电话 主动挂断 且是主动坐席挂断
				 var callId = releaseCall.callId;
				 var othercalCallId;
				 $.each(that.threePartyArr,function(){
					 othercalCallId = this;
				 });
				 $.each(that.takingArr,function(){
					 if(callId == this.callId){
						 that.timeTaskParames.closeTaskParam(this.drawingTime);
						 that.timeTaskParames.closeTaskParam(this.answerTime);
						 that.timeTaskParames.closeTaskParam(this.ringTime);
					 }else if(othercalCallId == this.callId){
						 j++; // 因为 j初始值为-1  所以这里再次加1
						 that.timeTaskParames.closeTaskParam(this.drawingTime);
						 that.timeTaskParames.closeTaskParam(this.answerTime);
						 that.timeTaskParames.closeTaskParam(this.ringTime);
						 return false;
					 }
					 j++;
				 });
			 }
			 // 移除 通话
			 if(j != -1){
				 if( j > i){
					 that.takingArr.splice(j, 1);
					 that.takingArr.splice(i, 1);
				 }else{
					 that.takingArr.splice(i, 1);
					 that.takingArr.splice(j, 1);
				 }
			 }else{
				 that.takingArr.splice(i, 1);
			 }
			 this.setShowAgentStatus(null, null, '您正在等待下一个电话. . . .', agentVersion);
			 if(that.takingArr.length == 0){
				 // 挂机 之后 需要将 坐席条 部分按钮 恢复原状
				 $('[by-model="keep"]').show();
				 $('[by-model="unkeep"]').hide();
				 that.threePartyArr.splice(0);
				 that.curTakingId = 0;
			 }
		 }else{
			 this.setShowAgentStatus(null, null, '您正在等待下一个电话. . . .', agentVersion);
			 this.btnClickAbles(['checkOut','checkIn','showBusy','showIdle','outbound','inbound']);
		 }
		 // 结束话后 时间
		 onWarpUpStatusChanged(releaseCall);
	 },
	 /**
	  * 外呼
	  */
	 outbound: function () { //  外呼
		 this.createOutCallPage(false);
	 },
	 /**
	  * 创建外呼的界面
	  * @param transferPhone 是否直接转接外部电话
	  * @param transferCallId 当前正在通话的Id
	  */
	 createOutCallPage :function(transferPhone,transferCallId){
		 var html = '<div class="back-g">'
			 + '<div class="show-msg">'
			 + '<div class="title">外拨<span class="close-btn">×</span></div>'
			 + '<table class="out-call-table">'
			 + '<tr><td class="title-cls" colspan="3">请输入外拨号码</td></tr>'
			 + '<tr><td class="phone-num-cls" colspan="3"><input class="inputNum" type="text" /></td></tr>'
			 + '<tr><td class="sub-cls" colspan="3"><input type="button" class="outCallBtn" value="确认"  /><input type="button" class="cancel-btn" value="取消" /></td></tr>'
			 + '<tr class="press-tr"><td class="press-num-cls"><input type="button" value="1"/></td><td class="press-num-cls"><input type="button" value="2"/></td><td class="press-num-cls"><input type="button" value="3"/></td></tr>'
			 + '<tr class="press-tr"><td class="press-num-cls"><input type="button" value="4"/></td><td class="press-num-cls"><input type="button" value="5"/></td><td class="press-num-cls"><input type="button" value="6"/></td></tr>'
			 + '<tr class="press-tr"><td class="press-num-cls"><input type="button" value="7"/></td><td class="press-num-cls"><input type="button" value="8"/></td><td class="press-num-cls"><input type="button" value="9"/></td></tr>'
			 + '<tr class="press-tr"><td class="press-num-cls"><input type="button" value="*"/></td><td class="press-num-cls"><input type="button" value="0"/></td><td class="press-num-cls"><input type="button" value="#"/></td></tr>'
			 + '</table></div></div>';
		 // 展示 外呼 窗口
		 $('body').append(html);
		 // 外呼窗口的 电话号码 框 获取焦点事件
		 $('.back-g .phone-num-cls input').focus();
		 // 点击 数字按钮 对应的事件
		 $('.back-g .press-tr input[type="button"]').click(function () {
			 var e = $('.back-g .phone-num-cls input');
			 e.val(e.val() + $(this).val());
		 });
		 // 当前窗口 提交  或者取消 事件
		 var that = this;
		 $('.back-g .sub-cls input[type="button"]').click(function () {
			 var cls = $(this).attr('class');
			 if ('outCallBtn' == cls) {
				 var outCallPhone = $('.back-g .phone-num-cls input').val();
				 if (outCallPhone != '') {
					 // 这里 是直接转电话
					 if(transferPhone){
						 that.sendMsgToAgentServer({
							 'msgId': 67,
							 'callId': transferCallId,
							 'agentInfo': 'ACD(' + outCallPhone + ')',
							 'ivrName': that.curLoginUser.TransCallIVR,
						 });
					 }else{ // 外呼
						 that.outCallPhone(outCallPhone);
					 }
				 }
				 $('.back-g').remove();
			 } else {
				 //$('.back-g .close-btn').click();
			 }
		 });
	 },
	 /**
	  * 内呼
	  */
	 inbound: function () {
		 var that = this;
		 $.each(that.takingArr, function () {
			 if (this.takingStatus == that.constant.call_user_answer
				 && this.callStatus == that.constant.call_user_in_side) {
				 that.curTakingId = this.callId;
			 }
		 });
		 this.sendMsgToAgentServer({
			 'msgId': -311
		 });
	 },
	 /**
	  * 转坐席
	  */
	 transferAgent: function () {
		 var that = this;
		 $.each(that.takingArr, function () {
			 if (this.takingStatus == that.constant.call_user_answer) {
				 that.curTakingId = this.callId;
			 }
		 });
		 this.sendMsgToAgentServer({
			 'msgId': -313
		 });
	 },
	 /**
	  * 转移
	  */
	 transfer: function () {
		 var curCall = null;
		 var that = this;
		 $.each(that.takingArr, function (e) {
			 if (this.takingStatus == that.constant.call_user_answer) {
				 curCall = this;
				 return false;
			 }
		 });
		 if (curCall == null && that.takingArr.length > 1) {
			 // 如果都不存在 正在通话  那么说明 上一个通话已经被等待  故而去 数组中最后一个通话 为当前通话
			 var curTakingLen = that.takingArr.length - 1;
			 curCall = that.takingArr[curTakingLen];
		 }
		 that.sendMsgToAgentServer({
			 'msgId': 77,
			 'agentCode': curCall.called,
			 'customerTakingId': that.curTakingId,
		 });
		 // 移除当前通话
		 this.threadDrawingAction({'callId': curCall.callId});
	 },
	 /**
	  * 三方
	  */
	 threeParty: function () {
		 var curCall = null;
		 var that = this;
		 $.each(that.takingArr, function (e) {
			 if (this.takingStatus == that.constant.call_user_answer) {
				 curCall = this;
				 return false;
			 }
		 });
		 if (curCall == null && that.takingArr.length > 1) {
			 return;
		 }
		 var lastIndex = 0;
		 if(curCall.callout) lastIndex = 1;

		 that.sendMsgToAgentServer({
			 'msgId': 75,
			 'agentCode': curCall.called,
			 'customerTakingId': that.curTakingId,
			 'lastIndex' : lastIndex,
		 });
		 this.threePartyArr.push(that.curTakingId);
		 this.threePartyArr.push(curCall.callId);
	 },
	 /**
	  * 释放转
	  */
	 releaseTurn : function(){
		 this.sendMsgToAgentServer({'msgId':-307});
	 },
	 /**
	  * 挂起转
	  */
	 hangUp : function(){
		 this.sendMsgToAgentServer({'msgId':-309});
	 },
	 /**
	  * 转 电话
	  */
	 transferPhone : function(){
		 var callId;
		 var that = this;
		 $.each(that.takingArr,function(){
			 if(this.isUsed == that.constant.call_user_taking){
				 callId = this.callId;
			 }
		 });
		 if(callId)
			 this.createOutCallPage(true,callId);
	 },
	 /**
	  * 转ACD
	  */
	 turnACD : function(){
		 this.sendMsgToAgentServer({'msgId':-317});
	 },
	 /**
	  * 质检
	  */
	 qualityTesting :function(){
		 this.sendMsgToAgentServer({'msgId':-319});
	 },
	 /**
	  * 取消质检
	  */
	 qualityTestingCancel :function(){
		 if(this.qualityNextStepMsg == null) return;
		 this.sendMsgToAgentServer(this.qualityNextStepMsg);
	 },
	 /**
	  * chat
	  */
	 chat :function(){},
	 /**
	  * 扩展
	  */
	 extend : function(){},
	 restartWebSocket : function (url){
		 var that = this;
		 if(that.curLoginUser.webSocketStatus == '0') return;
		  if(that.curLoginUser.AutoReconnect == 1){
			  setTimeout(function(){
				  console.info('正在尝试重新连接。。。。' + new Date());
				  initWebSocket(url);
			  },5000);
		  }
	 },
	 /**
	  * 外呼 调用
	  */
	 outCallPhone : function(phone){
		 var that = this;
		 if(!phone) return;
		 if(phone == '') return;
		 var newCall = {
				 'caller': '',
				 'called': phone,
				 'takingStatus': that.constant.call_user_not_use,
				 'callStatus': that.constant.call_user_out_side,
				 'isUsed': that.constant.call_user_taking,
				 'isInbound': 0,
				 'ringTime': 0,
				 'answerTime': 0,
				 'drawingTime': 0,
				 'askTime': '00:00',
				 'transfer': false,
				 'callout':true,
			 };
			 // 查询是否存在 正在 通话的 通话，存在  hold
			 var latterCallOut = false;
			 $.each(that.takingArr,function(){
				 if(this.takingStatus == that.constant.call_user_answer){
					 that.sendMsgToAgentServer({'msgId':81,'callId':this.callId});
					 latterCallOut = true;
					 that.curTakingId = this.callId;
					 return false;
				 }
			 });
			 that.takingArr.push(newCall);
			 if(latterCallOut){
				 setTimeout(function(){
					 that.sendMsgToAgentServer({
						 'msgId': 37,
						 'called': phone,
						 'callType': 2,
						 'transfer':0,
					 });
				 },500);
			 }else{
				 that.sendMsgToAgentServer({
					 'msgId': 37,
					 'called': phone,
					 'callType': 0,
				 });
			 }
			 $('#agentCallStatus [by-model="phoneNumber"]').val(phone);
	 },
	 callFail : function(){
		 var that = this;
		 var length = that.takingArr.length;
		 if(length > 0){
			 that.takingArr.splice(length-1, 1);
		 }
		 var showStatus = this.getShowAgentStatus()['phoneContent'];
		 that.setShowAgentStatus(null, null, '呼叫失败', null);
		 setTimeout(function(){
			 that.setShowAgentStatus(null, null, showStatus, null);
			 console.info(that.curTakingId,that.takingArr);
			 if(that.takingArr.length > 0){
				 $.each(that.takingArr,function(){
					 if(that.curTakingId == this.callId){
						 $('#agentCallStatus [by-model="phoneNumber"]').val(this.caller);
					 }
				 })
			 }
		 },2000);
	 },
	 /**
	  * 开启心跳检测
	  */
	 chkHeart : function(){
		 //wsHeartTimer
		 var that = this;
		 if(!this.curLoginUser.wsHeartTimer){
			 this.curLoginUser.wsHeartTimer = window.setInterval(function(){
				 var v = new Date().getTime() - that.curLoginUser.wsLastRecTime;
				 if(v > that.curLoginUser.wsTimeout * 1000){// 超时
					 //  关闭连接
					 that.curLoginUser.disconnectReason = '心跳检测60秒超时';
					 websocket.close();
				 }
			 },this.curLoginUser.wsInterval*1000);
		 }
	 },
	 /**
	  * 关闭心跳检测
	  */
	 closeHeart : function(){
		 this.timeTaskParames.closeTaskParam(this.curLoginUser.wsHeartTimer);
		 this.curLoginUser.wsHeartTimer = null;
	 },
 };

 /**
  * websocket 初始化需要的参数
  * @param currUserCode	坐席编号
  * @param currUserType	坐席类型
  * @param currUserTel	坐席电话
  * @param ipccIp	websocket服务端ip
  * @param ipccIpPort	websocket 服务端的端口
  */
 function initWebSocket(url) {
	 var errorIndex;
	 //判断当前浏览器是否支持WebSocket
	 if ('WebSocket' in window) {
		 console.info(url);
		 websocket = new WebSocket(url);
	 }
	 else {
		 alert('Not support websocket')
	 }

	 //连接发生错误的回调方法
	 websocket.onerror = function () {
 //    	console.info('webSocket.error');
 //        agentProxy.changeCheckStatusAction(false,'error');
	   //  agentProxy.restartWebSocket(url);
		 agentProxy.curLoginUser.disconnectReason = '登录错误断开';
		 if(agentProxy.curLoginUser.disconnectCallBack){
			 agentProxy.curLoginUser.disconnectCallBack(1,'登录错误');
		 }
	 };

	 //连接成功建立的回调方法
	 websocket.onopen = function (event) {
		 console.info('websocket 连接成功');
		 if(agentProxy.curLoginUser.disconnectCallBack){
			 agentProxy.curLoginUser.disconnectCallBack(1,'登录成功');
		 }
		 agentProxy.curLoginUser.webSocketStatus = '0';
		 agentProxy.curLoginUser.wsLastRecTime = new Date().getTime();
		 agentProxy.chkHeart();
		 agentProxy.curLoginUser.strongCheckOut = false;
		 agentProxy.sendMsgToAgentServer({
			 'msgId': -2,
			 'agentSipNumber':agentProxy.curLoginUser.agentSipNumber,
			 'agentCustName':agentProxy.curLoginUser.agentCustName,
			 'agentPassword':agentProxy.curLoginUser.agentPassword,
			 'GreetingEnable':agentProxy.curLoginUser.GreetingEnable,
			 'ServerIP' : agentProxy.curLoginUser.ServerIP,
			 'ServerQueueEnabled':agentProxy.curLoginUser.ServerQueueEnabled,
		 });
	 }

	 //接收到消息的回调方法
	 websocket.onmessage = function (event) {
		 var obj = agentProxy;
		 var data = JSON.parse(event.data);
		 // 语音系统人员信息	在线坐席状态信息	acd信息	等待和在线坐席人数  && data.msgId != 312   && data.msgId != 29
		 if(data.msgId != 303 && data.msgId != 302 && data.msgId != 301 && data.msgId != 312 && data.msgId != -500 && data.msgId != 29){
			 console.info('Receive : ',data);
		 }
		 switch (data.msgId) {
			 case -500:// acd 排队信息
				 obj.showACDCallMsg(data.data);
				 break;
			 case -320: // 质检返回 在线坐席
				 obj.qualityTestingAction(data.data);
				 break;
			 case -318:
				 obj.turnACDAction(data.data);
				 break;
			 case -314:
				 obj.transferAgentAction(data.data);
				 break;
			 case -312:
				 obj.inboundAction(data.data);
				 break;
			 case -310:
				 obj.hangUpAction(data.data);
				 break;
			 case -308:
				 obj.releaseTurnAction(data.data);
				 break;
			 case 0:
				 //  签入操作
				 obj.checkIn(true);
 //        		if(obj.leaveData.leaveModel == 1){//离席模式
 //        		    obj.sendMsgToAgentServer({
 //                        'msgId': 1,
 //                        'userNumber':obj.leaveData.leaveTel
 //                    });
 //				}else if(obj.leaveData.leaveModel == 0){
 //        		    obj.sendMsgToAgentServer({
 //                        'msgId':1
 //                    })
 //				}
 //        		obj.sendMsgToAgentServer({
 //                   'msgId' : 5,
 //                   'status' : 8,
 //                });
				 break;
			 case 2:
				 /**
				  * 普通坐席 正常 [2,IPCC,104,0,0,5,60,0x00000009,0x00000000,]
				  * 主管 正常     [2,IPCC,104,2,0,5,60,0x00000009,0x00000000,]
				  */
				 var status = Number(data.code);
				 switch (status){
					 case 0 :
						 var usertype = data.data.agentType;
						 obj.curLoginUser.Supervisor = usertype;
						 // 判断下 是否开启了心跳检测 如 未开启，则开启
						 if(!obj.curLoginUser.wsHeartTimer){
							 obj.curLoginUser.wsLastRecTime = new Date().getTime();
							 obj.chkHeart();
						 }
						 break;
					 default :
						 obj.changeCheckStatusAction(false,data.msg);
				 }
				 break;
			 case 5: // 服务器推送这种情况  被其他人改变状态
				 obj.curLoginUser.AgentStatus = data.data.status;
				 obj.changeWorkOrRestAction();
				 break;
			 case 6://坐席状态改变 示闲,示忙等
				 var status = data.data.status;
				 obj.changeCheckStatusAction(true);
				 obj.curLoginUser.AgentStatus = status;
				 if(obj.takingArr.length == 0){
					 obj.btnClickAbles(['checkOut','checkIn','showBusy','showIdle','outbound','inbound']);
					 obj.changeWorkOrRestAction();
				 }else{
					 obj.changeWorkOrRestAction('taking');
				 }
				 break;
			 case 8: // 关于欢迎语 是否启用的返回
				 obj.enableWelcomAction(data.code);
				 break;
			 case 9 : // 坐席从别处登录  或者被强制退出
				 obj.btnClickAbles(['checkIn']);
				 obj.changeCheckStatusAction(false,'您已经被服务器强制签出');
				 obj.curLoginUser.strongCheckOut = true; // 标志性 强制性 签出
				 obj.curLoginUser.disconnectReason = '坐席从别处登录  或者被强制退出'
				 debugger
				 websocket.close();
				 break;
			 case 10: // 坐席签出返回
				 // 关闭 心跳计时器
				 obj.closeHeart();
				 obj.btnClickAbles(['checkIn']);
				 obj.changeCheckStatusAction(false);
				 var isClickCheckOut = obj.curLoginUser.CkeckOutCase;
				 if(isClickCheckOut != ''){ // 说明 不是手动触发 签出按钮
					 // 判断 是否 启用了 离席模式
					 if(obj.leaveData.ckeckStatus == obj.constant.login_user_not_cancel_leaveData){
						 // 开启离席
						 obj.sendMsgToAgentServer({'msgId': 1,'userNumber':obj.leaveData.leaveTel});
						 obj.sendMsgToAgentServer({'msgId': 5, 'status': 8});
						 obj.sendMsgToAgentServer({'msgId': 7, 'status': 1});
						 obj.sendMsgToAgentServer({'msgId': 5, 'status': 1});
					 }else{
						 // 取消离席
						 agentProxy.checkIn();
						 obj.curLoginUser.CkeckOutCase = '';
					 }
				 }
				 var reconnect = data.data.reconnect;
				 if(reconnect == 1){
					 console.info('agent reconnect');
					 //obj.checkIn();
					 //initWebSocket(url);
					 obj.curLoginUser.disconnectReason = '坐席签出返回 重新连接'
					 websocket.close();
				 }
				 break;
			 case 29:
				 obj.curLoginUser.wsLastRecTime = new Date().getTime();
				 // 解决 座席状态与Server 状态不一致问题
				 if(obj.curLoginUser.AgentStatus != data.data.status && (data.data.status == '1' || data.data.status == '8')){
					 obj.curLoginUser.AgentStatus = data.data.status;
					 obj.changeWorkOrRestAction();
				 }
				 break;
			 case 31: // 来电接入 带入来电信息  坐席条不做任何变化
				 obj.incomingCall(data.data);
				 break;
			 case 33: // 振铃 事件  坐席条显示振铃信息
				 if(obj.curLoginUser.agentSoundType == 0){
					 obj.btnClickAbles(['checkOut','checkIn', 'showBusy','showIdle', 'threadDrawing']);
				 }else{
					 obj.btnClickAbles(['checkOut','checkIn', 'showBusy','showIdle', 'answer', 'threadDrawing']);
				 }
				 obj.onRing(data.data);
				 break;
			 case 35: // 电话坐席 坐席已经按下了接听按钮  服务器推送的事件
				 var callId = data.data.callId;
				 if(callId == 0x00000000){ //  如果 通话ID 是 0   则说明是内呼
					 if(obj.curTakingId != null && obj.curTakingId != 0){ // 说明 当前坐席 存在多个通话
						 obj.btnClickAbles(['checkOut','checkIn','showBusy','showIdle','threadDrawing','transfer','threeParty']);
					 }else{
						 obj.btnClickAbles(['checkOut','checkIn','showBusy','showIdle','threadDrawing']);
					 }
				 }else{
					 if(obj.curTakingId != null && obj.curTakingId != 0){
						 obj.btnClickAbles(['checkOut','checkIn','showBusy','showIdle','threadDrawing','transfer','threeParty']);
					 }else{
						 obj.btnClickAbles(['checkOut','checkIn','showBusy','showIdle','threadDrawing','keep','unkeep','outbound','inbound','transferAgent','releaseTurn','hangUp','transferPhone','turnACD']);
					 }
				 }
				 obj.answerAction(data.data);
				 break;
			 case 36: // 声卡坐席

				 break;
			 case 37:// 内呼 推送的消息
				 obj.btnClickAbles(['checkOut','checkIn', 'showBusy','showIdle', 'threadDrawing',]);
				 obj.internalCallAction(data.data);
				 break;
			 case 38: // 外呼返回
				 var status = data.data.status;
				 if(status == 0){
					 obj.btnClickAbles(['checkOut','checkIn', 'showBusy','showIdle', 'threadDrawing',]);
					 obj.outCallAction(data.data);
				 }else{ // 外呼失败  坐席条不做变化  正在通话的 数组 减一
					 obj.callFail();
				 }
				 break;
			 case 39: // 客户挂机 返回 （包含 电话坐席 坐席触发挂机动作）
				 obj.btnClickAbles(['checkOut','checkIn','showBusy','showIdle','afterSpeech']);
				 obj.threadDrawingAction(data.data,true);
				 break;
			 case 40:// 坐席条请求挂机  返回
				 obj.btnClickAbles(['checkOut','checkIn','showBusy','showIdle','afterSpeech']);
				 obj.threadDrawingAction(data.data,false);
				 break;
			 case 48:
				 obj.qualityTestingACKAction(data.data,true,'拦截');
				 break;
			 case 50 :
				 obj.qualityTestingACKAction(data.data,false,'停止拦截');
				 break;
			 case 52:
				 obj.qualityTestingACKAction(data.data,true,'强拆');
				 break;
			 case 60:
				 obj.qualityTestingACKAction(data.data,true,'强制签出');
				 break;
			 case 62:
				 obj.qualityTestingACKAction(data.data,true,'强制改变状态');
				 break;
			 case 64:
				 obj.qualityTestingACKAction(data.data,true,'强接');
				 break;
			 case 66: // 双击强接结果
				 obj.strongConnectCall(data.data);
				 break;
			 case 76 : // 三方 请求应答
				 obj.btnClickAbles(['checkOut','checkIn','showBusy','showIdle','threadDrawing']);
				 obj.threePartyAction(data.data);
				 break;
			 case 78: // 转移 返回

				 break;
			 case 79: // 通话被转移过来
				 var callId = data.data.callId;
				 if(callId == 0x00000000){ //  如果 通话ID 是 0   则说明是内呼
					 obj.btnClickAbles(['checkOut','checkIn','showBusy','showIdle','threadDrawing']);
				 }else{
					 obj.btnClickAbles(['checkOut','checkIn','showBusy','showIdle','threadDrawing','keep','unkeep','outbound','inbound','transferAgent','releaseTurn','hangUp','transferPhone','turnACD']);
				 }
				 obj.transferCallAction(data.data);
				 break;
			 case 82: // 请求保持 结果返回
				 obj.keepAction(data);
				 break;
			 case 84://取回 保持的通话
				 obj.unkeepAction(data);
				 break;
			 case 87:// 三方会议其中一方挂断后 推送的消息
				 obj.btnClickAbles(['checkOut','checkIn','showBusy','showIdle','threadDrawing','keep','unkeep','outbound','inbound','transferAgent']);
 //            	obj.awakenOtherCallAction(data.data);
				 break;
			 case 98:// 未接听 坐席条 挂断
				 obj.btnClickAbles(['checkOut','checkIn','showBusy','showIdle','afterSpeech']);
				 obj.threadDrawingAction(data.data);
				 break;
			 case 106:
				 obj.qualityTestingACKAction(data.data,true,'插话');
				 break;
			 case 108:
				 obj.qualityTestingACKAction(data.data,true,'监听');
				 break;
			 case 110:
				 obj.qualityTestingACKAction(data.data,false,'停止监听');
				 break;
			 case 301:// 排队人数 和在线人数
				 obj.showWaitAndOnlineNum(data.data);
				 break;
		 }
	 }

	 //连接关闭的回调方法
	 websocket.onclose = function () {
		 console.info('wbsocket服务连接断开');
		 util.error('呼叫中心服务连接断开！');
		 rem(".connATC", 'ACT未连接');

		 agentProxy.btnClickAbles('');
		 agentProxy.curLoginUser.webSocketStatus = '1';
		 if(agentProxy.curLoginUser.disconnectCallBack){
			 agentProxy.curLoginUser.disconnectCallBack(2,agentProxy.curLoginUser.disconnectReason);
		 }
		 // 关闭 检测 计时器
		 agentProxy.closeHeart();
		 // 系统强制签出 高于一切配置。。包含自动重连
		 if(!agentProxy.curLoginUser.strongCheckOut){
			 agentProxy.changeCheckStatusAction(false,'wbsocket服务连接断开');
			 agentProxy.restartWebSocket(url);
			 if(agentProxy.curLoginUser.disconnectCallBack){
				 agentProxy.curLoginUser.disconnectCallBack(3,'重连');
			 }
		 }
	 }

	 //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
	 window.onbeforeunload = function () {
		 agentProxy.curLoginUser.disconnectReason = '窗口关闭事件断开连接';
		 websocket.close();
	 }
 }

 /**
  * 坐席登录 初始化
  * @param webSocketIP	agentProxy IP地址
  * @param webSocketPort	agentProxy 端口
  * @param serverIp	IPCC服务器端口
  * @param agentType		坐席类型 参数为 声卡坐席 和 电话坐席
  * @param agentCode		坐席编号
  * @param agentPwd		坐席登录的密码
  * @param agentTel		坐席电话号码
  * @param requestType		请求类型
  * @returns
  */
 function agentInit(webSocketIP,webSocketPort,serverIp,agentType,agentCode,agentPwd,agentTel,requestType,disconnectCallBack){
	 var agent = agentProxy.curLoginUser;
	 agent.WebSocketIP = webSocketIP;
	 agent.WebSocketPort = webSocketPort;
	 agent.ServerIP = serverIp;
	 agent.agentSoundType = agentType ;
	 agent.agentUserName = agentCode ;
	 agent.agentPassword = agentPwd ;
	 agent.agentSipNumber = agentTel ;
	 agent.disconnectCallBack = disconnectCallBack ;
	 if(requestType) agent.isHttps = requestType === 'https';
	 agentProxy.init();
 }

 /*******************************************/
 // 来电信息
 function onRingCall(callUser){
	telephonePopup(callUser);
 }
 // 外呼
 function outCallPhone(phone){
	 agentProxy.outCallPhone(phone);
 }

 //固定电话外呼
 function outCallFixedLine(phone){
	$.get(SERVER + '/comm/queryPhoneIsLocal', { phone: phone }, (json) => {
		console.log(json);
		if (json.status === 0) {
			if(json.message == ''){
				util.error("未检测到手机号前缀,请使用话机拨打！");

				// bootbox.confirm({
				// 	message: '未检测到号码归属地，'+phone+'是否为本机号码?',
				// 	size: 'small',
				// 	buttons: {
				// 		confirm: {
				// 			label: '确定',
				// 			className: 'btn-primary'
				// 		},
				// 		cancel: {
				// 			label: '取消'
				// 		}
				// 	},
				// 	callback: function (result) {
				// 		if (result) {
				// 			agentProxy.outCallPhone('9'+phone);
				// 			$.get(SERVER + '/comm/StaffPhoneLocation', { location:'济南',phone: phone }, (json) => {
				//
				// 			})
				// 		} else {
				// 			agentProxy.outCallPhone(phone);
				// 		}
				// 	}
				// })
				return ;
			}else{
				agentProxy.outCallPhone(json.message+phone);
			}
		}
	})

}


 // 转接 电话 弹屏
 function onTransferIn(callUser){
	telephonePopup(callUser);  //呼出来电窗口
	phonPopup.pickup(boxId);   //修改来电状态为通话中  确认转接后 会走这个方法
 }
 // 应答
 function onCallAnswered(callUser){
	phonPopup.pickup(boxId);  //通话中调用
 }
 //话后结束
 function onWarpUpStatusChanged(){}
 // 收到挂机信号
 function onCallReleased(){
	phonPopup.hangup(boxId);
 }
 // 签入 操作
 function onLoginSucc(){}
 // 签出操作
 function onLogout(){}
 // 坐席更改状态
 function onStatusChanged(status){}
 // 外呼应答
 function onCalloutAnswered(callUser){}

 function telephonePopup(callUser){
	var callObj = {};
	callObj.callId = callUser.sessionId//callUser.sessionId;
    callObj.callType = 1;
    callObj.customerType = '';
    callObj.uidName = localStorage.getItem('loginName');	      	//坐席姓名
    callObj.atcUid =  localStorage.getItem('loginUid') ;		  	//座席员工号
    callObj.atcExt =  localStorage.getItem('loginExt') ;			//分机号
	callObj.phone = callUser.caller
	boxId = phonPopup.showPhonePupup(callObj, (boxId) => {//clickInfo
		// var boxInfo =   phonPopup.getBoxInfo(boxId);
		// var phone = (boxInfo&&boxInfo.phone)||'';
		// var href = '/my-ATC-detail.html?phone='+phone+'&boxId='+boxId;
		// //ATCBox.setBoxInfo({'winHref':href}, boxId);
		// top.base.openWindow(phone, href);
	});
	localStorage.setItem('boxId='+boxId,'1');
	var href = '/call-info-detail.html?phone='+callObj.phone+'&boxId='+boxId;
	top.base.openWindow(callObj.phone, href);

	//phonPopup.pickup(boxId);
	return boxId;
}
function rem(selector, strMsg) {
    $(selector).html(strMsg);
}

export{
	agentInit,
	agentProxy,
	telephonePopup,
	outCallPhone,
	outCallFixedLine,
	websocket
}
